/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfGuid } from "../models/AjaxResponseOfGuid";
import type { AjaxResponseOfListOfVehicleManagementInfosDto } from "../models/AjaxResponseOfListOfVehicleManagementInfosDto";
import type { AjaxResponseOfVehicleManagementInfosDto } from "../models/AjaxResponseOfVehicleManagementInfosDto";
import type { VehicleManagementInfoCreateDto } from "../models/VehicleManagementInfoCreateDto";
import type { VehicleManagementInfoUpdateDto } from "../models/VehicleManagementInfoUpdateDto";

import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";

export class VehicleManagementInfosAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * @returns AjaxResponseOfListOfVehicleManagementInfosDto
   * @throws ApiError
   */
  public getAll({
    id,
  }: {
    id: string;
  }): CancelablePromise<AjaxResponseOfListOfVehicleManagementInfosDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/vehicle-management-info/{id}/todos",
      path: {
        id: id,
      },
    });
  }

  /**
   * @returns AjaxResponseOfVehicleManagementInfosDto
   * @throws ApiError
   */
  public getById({
    id,
  }: {
    id: string;
  }): CancelablePromise<AjaxResponseOfVehicleManagementInfosDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/vehicle-management-info/{id}",
      path: {
        id: id,
      },
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public delete({ id }: { id: string }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/front-end/v1/vehicle-management-info/{id}",
      path: {
        id: id,
      },
    });
  }

  /**
   * @returns AjaxResponseOfGuid
   * @throws ApiError
   */
  public create({
    requestBody,
  }: {
    requestBody?: VehicleManagementInfoCreateDto;
  }): CancelablePromise<AjaxResponseOfGuid> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/vehicle-management-info",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public update({
    requestBody,
  }: {
    requestBody?: VehicleManagementInfoUpdateDto;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/api/front-end/v1/vehicle-management-info",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }
}
